import { useContext } from 'react';
import { NotificationContext, NotificationContextValue } from './notificationContextDef';

export const useNotification = (): NotificationContextValue => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
